import addNamespace from '../addNamespace';

const GET_COUNTRIES_REQUEST = 'GET_COUNTRIES_REQUEST';
const GET_COUNTRIES_SUCCESS = 'GET_COUNTRIES_SUCCESS';
const GET_COUNTRIES_FAILURE = 'GET_COUNTRIES_FAILURE';

export default addNamespace({
  GET_COUNTRIES_REQUEST,
  GET_COUNTRIES_SUCCESS,
  GET_COUNTRIES_FAILURE,
}, 'countries');
